<script>
import { ArrowUpIcon } from 'vue-feather-icons';

import Navbar from "@/components/navbar";
import Footer from "@/components/footer";

export default {
    data() {
        return {}
    },
    components: {
        Navbar,
        Footer,
        ArrowUpIcon
    }
}
</script>

<template>
<div>
    <Navbar />

    <!-- Hero Start -->
    <section class="bg-half-170 bg-light d-table w-100">
        <div class="container">
            <div class="row mt-5 justify-content-center">
                <div class="col-lg-12 text-center">
                    <div class="pages-heading">
                        <h2 class="title mb-0">Lexmark Products & Solutions</h2>
                    </div>
                </div>
            </div>
        </div>
    </section>
    <div class="position-relative">
        <div class="shape overflow-hidden text-white">
            <svg viewBox="0 0 2880 48" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M0 48H1437.5H2880V0H2160C1442.5 52 720 0 720 0H0V48Z" fill="currentColor"></path>
            </svg>
        </div>
    </div>
    <!-- Hero End -->

    <!-- Section 1: Lexmark Overview - Two Columns -->
    <section class="section">
        <div class="container">
            <div class="row align-items-center">
                <div class="col-lg-4 col-md-5 text-center mb-4 mb-md-0">
                    <img src="/images/brands/lexmark.png" class="img-fluid" style="max-width: 200px;" alt="Lexmark Logo" />
                </div>
                <div class="col-lg-8 col-md-7">
                    <div class="section-title text-center text-md-left">
                        <h3 class="title mb-4">Lexmark is now part of Xerox</h3>
                        <h5 class="text-primary mb-4">Higher performance at lower cost</h5>
                        <p class="text-muted para-desc">
                            Whether your business fills a room or circles the globe, Lexmark offers the imaging solutions, technologies and services you need to succeed.
                        </p>
                    </div>
                </div>
            </div>
        </div>
    </section>

    <!-- Section 2: 9-Series Printers & MFPs - Left Aligned -->
    <section class="section bg-light">
        <div class="container">
            <div class="row align-items-center">
                <div class="col-lg-6 col-md-6">
                    <div class="section-title">
                        <h3 class="title mb-4">9-Series Printers & MFPs</h3>
                        <p class="text-muted para-desc">
                            An extensive line of reliable, easy-to-maintain and fast-to-service 9-Series printers and MFPs, all manageable via Lexmark Cloud Services with its new AI-powered document enhancement that offers customers a range of solutions for a variety of workgroup sizes.
                        </p>
                    </div>
                </div>

                <div class="col-lg-6 col-md-6 mt-4 mt-sm-0 pt-2 pt-sm-0">
                    <div class="ml-lg-5">
                        <div class="card border-0 rounded shadow bg-white">
                            <div class="card-body p-4">
                                <div class="d-flex align-items-center mb-3">
                                    <i class="uil uil-cloud-computing h2 text-primary mb-0"></i>
                                    <h5 class="mb-0 ml-3">Cloud & AI Powered</h5>
                                </div>
                                <p class="text-muted mb-0">Manageable via Lexmark Cloud Services with AI-powered document enhancement.</p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </section>

    <!-- Section 3: Versatility & Maintenance - Right Aligned -->
    <section class="section">
        <div class="container">
            <div class="row align-items-center">
                <div class="col-lg-6 col-md-6 order-2 order-md-1 mt-4 mt-sm-0 pt-2 pt-sm-0">
                    <div class="mr-lg-5">
                        <div class="card border-0 rounded shadow bg-light">
                            <div class="card-body p-4">
                                <div class="d-flex align-items-center mb-3">
                                    <i class="uil uil-wrench h2 text-primary mb-0"></i>
                                    <h5 class="mb-0 ml-3">Effortless Maintenance</h5>
                                </div>
                                <p class="text-muted mb-0">Intuitive panels, one-handed toner replacement, and modular components.</p>
                            </div>
                        </div>
                    </div>
                </div>

                <div class="col-lg-6 col-md-6 order-1 order-md-2">
                    <div class="section-title">
                        <h3 class="title mb-4">Versatility & Performance</h3>
                        <p class="text-muted para-desc mb-4">
                            It provides a 9-Series lineup offers a versatile range of printers and MFPs, catering to diverse business needs with various price points, speeds from 25 to 55 pages per minute, and exceptional color options.
                        </p>
                        <p class="text-muted para-desc">
                            Lexmark's 9-Series printers and MFPs are designed for effortless maintenance and servicing, featuring intuitive operator panels, one-handed toner replacement, and modular components that simplify technician training and reduce service time.
                        </p>
                    </div>
                </div>
            </div>

            <!-- CTA -->
            <div class="row justify-content-center mt-5">
                <div class="col-lg-10 text-center">
                    <router-link to="/contact-us" class="btn btn-primary">Contact Us for More Information</router-link>
                </div>
            </div>
        </div>
    </section>

    <Footer />
    <!-- Back to top -->
    <a href="javascript: void(0);" class="btn btn-icon btn-primary back-to-top" id="back-to-top" v-scroll-to="'#topnav'">
        <arrow-up-icon class="icons"></arrow-up-icon>
    </a>
</div>
</template>
